export enum ResetPasswordEntity {
  USER = 'user',
  RESOURCE = 'resource'
}

export interface ResetPasswordProps {
  type: ResetPasswordEntity
  entityId: number
  email: string
  disabled?: boolean
}
